<template>
  <section>
    <AprobarPermiso />
    <AprobarPermisoOficialPorHoras />
    <RechazarPermisoOficialPorHoras />
    <VerPermisoJefe />
    <VerDocumento />
    <h3 class="primary--text">
      <v-icon info>exit_to_app</v-icon>Aprobación/Rechazo de
      permisos-licencias-omisiones (Jefe)
    </h3>
    <!-- Seleccionar gestion-->
    <v-flex xs12 md6>
      <v-autocomplete
        :items="lista_gestiones"
        item-text="periodo"
        item-value="periodo"
        label="Seleccione la gestión"
        v-model="periodo_seleccionado"
        @change="actualizaCrudTable()"
        required
        outline
        success
        clearable
      ></v-autocomplete>
    </v-flex>
    <v-card>
      <v-card-text>
        <crud-table
          v-if="sw_crud_table"
          class="tabla-comprimida-light"
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :widthModal="840"
          :initData="initData"
        >
          <template slot="items" slot-scope="items">
            <td>{{ items.item.numero }}</td>
            <td>{{ items.item.nombres }}</td>
            <td>{{ items.item.fecha_emision }}</td>
            <td>{{ items.item.fecha_desde }}</td>
            <td>{{ items.item.fecha_retorno }}</td>
            <td>{{ items.item.tipo_permiso }}</td>
            <td>{{ items.item.estado_permiso }}</td>
            <td>{{ items.item.horas_permiso }}</td>
            <td>
              {{
                items.item.id_tipo_permiso == 90 ? items.item.motivo : "Otros"
              }}
            </td>
            <td v-if="!items.item.nro_dias">0</td>
            <td v-if="items.item.nro_dias">{{ items.item.nro_dias }}</td>
            <td>{{ items.item.jefe ? items.item.jefe : "" }}</td>
            <td>{{ items.item.justificacion }}</td>
            <td>
              <v-btn
                color="info"
                @click.prevent="verPermisoJefe(items.item)"
                icon
                title="Ver permiso"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>

              <!-- btn de aprobacion oficial por hrs-->
              <!-- btn de aprobacion licencia por duelo 6-->
              <!-- btn de aprobacion licencia por paternidad 61-->
              <!-- btn de aprobacion licencia por matrimonio 12-->
              <v-btn
                v-if="
                  (items.item.id_estado == 6 ||
                    items.item.id_estado == 21 ||
                    items.item.id_estado == 12 ||
                    items.item.id_estado == 7) &&
                    items.item.aprobar == 1
                "
                color="success"
                @click.prevent="aprobarPermisoOficialPorHoras(items.item)"
                icon
                title="Aprobar permiso"
              >
                <v-icon>done</v-icon>
              </v-btn>

              <v-btn
                v-if="
                  (items.item.id_estado == 6 ||
                    items.item.id_estado == 21 ||
                    items.item.id_estado == 12 ||
                    items.item.id_estado == 7) &&
                    items.item.aprobar == 1
                "
                dark
                color="#E61C5B"
                @click.prevent="rechazarPermisoOficialPorHoras(items.item)"
                icon
                title="Rechazar permiso"
              >
                <v-icon>close</v-icon>
              </v-btn>

              <!-- btn de aprobacion otros -->

              <!-- <v-btn
                v-if="
                  (items.item.id_estado == 6 || items.item.id_estado == 7) &&
                    items.item.aprobar == 1 &&
                    items.item.id_tipo_permiso != 87 &&
                    items.item.id_tipo_permiso != 88 &&
                    items.item.id_tipo_permiso != 6 &&
                    items.item.id_tipo_permiso != 61 &&
                    items.item.id_tipo_permiso != 37 &&
                    items.item.id_tipo_permiso != 38 &&
                    items.item.id_tipo_permiso != 39 &&
                    items.item.id_tipo_permiso != 40 &&
                    items.item.id_tipo_permiso != 41 &&
                    items.item.id_tipo_permiso != 42 &&
                    items.item.id_tipo_permiso != 43 &&
                    items.item.id_tipo_permiso != 44
                "
                color="success"
                @click.prevent="aprobarPermisoOficialPorHoras(items.item)"
                icon
                title="Aprobar permiso.."
              >
                <v-icon>done</v-icon>
              </v-btn>

              <v-btn
                v-if="
                  (items.item.id_estado == 6 || items.item.id_estado == 7) &&
                    items.item.aprobar == 1 &&
                    items.item.id_tipo_permiso != 87 &&
                    items.item.id_tipo_permiso != 88 &&
                    items.item.id_tipo_permiso != 6 &&
                    items.item.id_tipo_permiso != 61 &&
                    items.item.id_tipo_permiso != 37 &&
                    items.item.id_tipo_permiso != 38 &&
                    items.item.id_tipo_permiso != 39 &&
                    items.item.id_tipo_permiso != 40 &&
                    items.item.id_tipo_permiso != 41 &&
                    items.item.id_tipo_permiso != 42 &&
                    items.item.id_tipo_permiso != 43 &&
                    items.item.id_tipo_permiso != 44
                "
                color="#E61C5B"
                @click.prevent="rechazarPermisoOficialPorHoras(items.item)"
                icon
                title="Rechazar permiso."
              >
                <v-icon>close</v-icon>
              </v-btn> -->

              <v-btn
                color="info"
                v-if="items.item.ruta_archivo"
                @click.native="verDocumento(items.item)"
                title="Ver documento"
                icon
              >
                <v-icon>attach_file</v-icon>
              </v-btn>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table-sin-orden/CrudTable.vue";
import crud from "@/common/util/crud-table/mixins/crud-table";
import AprobarPermiso from "./dialogs/AprobarPermiso";
import VerPermisoJefe from "./dialogs/VerPermisoJefe";
import VerDocumento from "./dialogs/VerDocumento.vue";
import AprobarPermisoOficialPorHoras from "./dialogs/AprobarPermisoOficialPorHoras.vue";
import RechazarPermisoOficialPorHoras from "./dialogs/RechazarPermisoOficialPorHoras";

export default {
  mixins: [crud],
  async mounted() {
    await this.obtenerListaGestiones();
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogRechazaPermiso", () => {
      this.updateList();
    });
    this.onFilter();
  },
  data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: "vPermisosPorJefes",
      periodo_seleccionado: new Date().getFullYear(),
      lista_gestiones: [],
      headers: [
        { text: "Nro", value: "numero", sortable: true },
        { text: "Nombres", value: "nombres", sortable: true },
        { text: "Fecha solicitud", value: "fecha_emision", sortable: true },
        { text: "Fecha salida", value: "fecha_desde", sortable: true },
        { text: "Fecha fin", value: "fecha_retorno", sortable: true },
        { text: "Nombre del permiso", value: "tipo_permiso", sortable: true },
        { text: "Estado", value: "estado_permiso", sortable: true },
        { text: "Horas", value: "horas_permiso", sortable: true },
        { text: "Tipo", value: "motivo", sortable: true },
        { text: "Días", value: "nro_dias", sortable: true },
        { text: "Solicitud enviada a", value: "jefe", sortable: true },
        { text: "Justificación", value: "justificacion", sortable: true },
        { text: this.$t("common.actions"), sortable: false }
      ],
      dataGraphql: `
          id
          id_permiso
          ruta_archivo
          lugar
          id_tipo_permiso
          fecha_nac_muerte
          hora_nac_muerte
          id_funcionario
          id_jefe
          gestion
          nombres
          numero
          fecha_emision
          tipo_permiso
          fecha_retorno
          estado_permiso
          nro_dias
          horas_permiso
          fecha_desde
          id_estado
          aprobar
          motivo
          justificacion
          jefe
      `,

      filters: [
        {
          field: "numero",
          label: "Numero",
          type: "text",
          typeG: "String"
        },
        {
          field: "nombres",
          label: "Nombres",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_emision",
          label: "Fecha solicitud",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_desde",
          label: "Fecha salida",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_retorno",
          label: "Fecha retorno",
          type: "text",
          typeG: "String"
        },
        {
          field: "tipo_permiso",
          label: "Nombre del permiso",
          type: "text",
          typeG: "String"
        },
        {
          field: "horas_permiso",
          label: "Horas",
          type: "text",
          typeG: "String"
        },
        // {
        //   field: "motivo",
        //   label: "Tipo",
        //   type: "text",
        //   typeG: "String"
        // },
        {
          field: "nro_dias",
          label: "Dias",
          type: "text",
          typeG: "String"
        },
        {
          field: "estado_permiso",
          label: "Estado de permiso",
          type: "text",
          typeG: "String"
        }
      ],

      // initData: [
      //   {
      //     state: true,
      //     param: "id_jefe",
      //     value: this.getUserId(),
      //   },
      //   {
      //     //excluir permiso
      //     state: true,
      //     param: "lista_tipo_permisos",
      //     value: '"24,8"',
      //   },
      // ],
      events: [],
      sw_crud_table: true,
      valid: true
    };
  },
  computed: {
    // convert the list of events into a map of lists keyed by date
    eventsMap() {
      const map = {};
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    },
    initData() {
      let data = [
        {
          state: true,
          param: "id_jefe",
          value: this.getUserId()
        },
        {
          //excluir permiso
          state: true,
          param: "lista_tipo_permisos",
          value: '"24,8"'
        },
        {
          state: true,
          param: "gestion",
          value: this.periodo_seleccionado
        }
      ];

      // }
      return data;
    }
  },
  methods: {
    // Metodo para actualizar el crud table con una gestion
    async actualizaCrudTable() {
      if (!this.periodo_seleccionado) {
        return;
      }
      this.sw_crud_table = false;
      await new Promise(resolve => setTimeout(resolve, 100));
      this.updateList();
      this.sw_crud_table = true;
    },
    open(event) {
      alert(event.title);
    },
    //metodo para obtener las gestiones:
    async obtenerListaGestiones() {
      try {
        this.lista_gestiones = [
          { periodo: 2023 },
          { periodo: 2024 },
          { periodo: 2025 },
          { periodo: 2026 }
        ];
      } catch (error) {
        console.log(error);
      }
    },
    aprobarPermiso(item) {
      this.$bus.$emit("openDialogAprobarPermiso", item);
    },
    aprobarPermisoOficialPorHoras(item) {
      this.$bus.$emit("openDialogAprobarPermisoOficialPorHoras", item);
    },
    rechazarPermisoOficialPorHoras(item) {
      this.$bus.$emit("openDialogRechazarPermisoOficialPorHoras", item);
    },
    getUserId() {
      const user = this.$storage.get("user");
      console.log("+++", user.id_persona);
      return user.id_persona;
    },
    verPermisoJefe(item) {
      this.$bus.$emit("openDialogVerPermisoJefe", item);
      console.log("openDialogVerPermisoJefe", item);
    },
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    }
  },
  components: {
    CrudTable,
    AprobarPermiso,
    VerPermisoJefe,
    VerDocumento,
    AprobarPermisoOficialPorHoras,
    RechazarPermisoOficialPorHoras
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/PermisoJefeAprobacion.vue